import React, { useState, useEffect } from 'react';
import Masonry from 'react-masonry-css';

import { ITileGridFields } from '../../../types/contentful';

import { breakpoints } from '../../styles/media-queries';

import { QuickStartGuideBox } from '../QuickStartGuideBox';
import { ScrollReveal } from '../ScrollReveal';

import {
  MASONRY_CLASS,
  MASONRY_COL_CLASS
} from '../MasonryWrapper';

export function TileGrid({ boxes }: ITileGridFields) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(
      typeof window !== `undefined` && window.innerWidth < breakpoints.tablet
    );
  }, []);

  return (
    <ScrollReveal>
      <div
        className="block-container mt-0 mb-12 tablet:mt-16 tablet:mb-16"
        data-blockid="tile-grid"
        data-testid="tile-grid"
      >
        <div className="flex flex-wrap justify-center items-center box-border w-full -mx-2 tablet:-mx-3 desktop:-mx-4">
          <div className="box-column w-full desktop:w-10/12 pt-0 desktop:pt-1 px-2 tablet:px-3 desktop:px-4">
            {isMobile ? (
              (boxes || []).map(({ sys, fields }) => (
                <QuickStartGuideBox {...fields} key={sys.id} />
              ))
            ) : (
              <div className="masonry-wrapper">
                <Masonry
                  breakpointCols={2}
                  className={MASONRY_CLASS}
                  columnClassName={MASONRY_COL_CLASS}
                >
                  {(boxes || []).map(({ sys, fields }) => (
                    <QuickStartGuideBox {...fields} key={sys?.id} />
                  ))}
                </Masonry>
              </div>
            )}
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
